import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import { Cached } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"

export default function ResetButton({ resetRebalance, disabled }) {
  return <Tooltip title="Reset trades" classes={{ popper: "rebalance-option" }}>
    <span>
      <IconButton id="reset-simulation-button" onClick={resetRebalance} size="large" disabled={disabled}>
        <Cached />
      </IconButton>
    </span>
  </Tooltip>
}

ResetButton.propTypes = {
  resetRebalance: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
